<template>
    <div>
        <div style="position: relative;width:10rem;height:5.15rem;">
            <img src="../../image/businessHandlingCenter/bg-top.png" alt="" style="width:10rem;height:4.35rem;">

            <div class="flex-start" style="position: absolute;top:0.67rem;width:10rem;height: 1.6rem;">
                <img src="http://b-ssl.duitang.com/uploads/item/201503/14/20150314210248_tKtVe.jpeg" alt="" style="margin-left:0.72rem;width:1.6rem;height:1.6rem;border-radius:50%;">
                <div style="margin-left:0.32rem;width:6.26rem;height:0.51rem;line-height:0.51rem;font-size:0.53rem;font-family:PingFang SC;font-weight:bold;color:rgba(51,51,51,1);">欧阳小微</div>
                <div class="flex-center" style="width:0.59rem;height:0.65rem;">
                    <img src="../../image/businessHandlingCenter/right-white.png" alt="" style="width:0.21rem;height:0.35rem;" />
                </div>
            </div>


            <div class="flex-start" style="position: absolute;bottom: 0rem;left:0.32rem;width:9.36rem;height:2.43rem;background:rgba(255,255,255,1);border-radius:27px;">
                <div v-for="(item,index) in [{title:'我的待办',click:myWaitHandle},{title:'办理中',click:inHandling},{title:'全部事项',click:allBusiness}]" @click="item.click" style="width:3.12rem;height:2.43rem;">

                    <!--判断,因为图片的路径会经过编译转换,变量的路径会有问题-->
                    <img v-if="index==0" src="../../image/businessHandlingCenter/myWaitHandle.png" alt="" style="padding:0.48rem 1.16rem 0.28rem;display: block;width: 0.8rem;height:0.8rem;">
                    <img v-if="index==1" src="../../image/businessHandlingCenter/inHandling.png" alt="" style="padding:0.48rem 1.16rem 0.28rem;display: block;width: 0.8rem;height:0.8rem;">
                    <img v-if="index==2" src="../../image/businessHandlingCenter/allBusiness.png" alt="" style="padding:0.48rem 1.16rem 0.28rem;display: block;width: 0.8rem;height:0.8rem;">

                    <div style="height:0.35rem;line-height:0.35rem;text-align: center;font-size:0.37rem;font-family:PingFang SC;font-weight:500;color:rgba(51,51,51,1);">{{item.title}}</div>
                </div>
            </div>
        </div>



        <div style="margin-top:0.32rem;margin-left:0.32rem;width:9.36rem;background:rgba(255,255,255,1);border-radius:0.27rem;">
            <div v-for="(item,index) in [{title:'意见反馈',click:feedback},{title:'设置',click:setUp}]" @click="item.click" class="flex-between" style="position: relative;width:9.36rem;height:1.28rem;">

                <!--绝对定位-->
                <div v-if="0<index" style="position: absolute;top: 0rem;left:0.4rem;width:8.96rem;height:1px;background:rgba(233,233,233,1);border-radius:0.27rem;"></div>

                <div style="margin-left:0.41rem;font-size:0.37rem;font-family:PingFang SC;font-weight:400;color:rgba(51,51,51,1);">{{item.title}}</div>
                <img src="../../image/businessHandlingCenter/right-gray.png" alt="" style="margin-right:0.39rem;width:0.21rem;height:0.35rem;">
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "businessHandlingCenter",
        data() {
            return {

            }
        },
        methods: {
            myWaitHandle(){
                console.log("我的待办")
            },
            inHandling(){
                console.log("办理中")
            },
            allBusiness(){
                console.log("全部事项")
            },
            feedback(status) {
                console.log("意见反馈")
            },
            setUp(status) {
                console.log("设置")
            }
        }
    }
</script>

<style scoped>
    .flex-center{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:center;
    }
    .flex-start{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:flex-start;
    }
    .flex-end{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:flex-end;
    }
    .flex-between{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:space-between;
    }
    .flex-around{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:space-around;
    }
</style>
